import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useModal } from '@europrocurement/flexy-components';

export type NavigateToExternalUrlProps = {
    externalUrl: string;
};

const NavigateToExternalUrlModal: React.FunctionComponent<NavigateToExternalUrlProps> = function (
    props,
) {
    const { externalUrl } = props;
    const { modalActions } = useModal();
    const handleCancel = () => modalActions.close();
    const handleSubmit = () => window.open(externalUrl, '_blank');

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '1em' }}>
            <Typography variant="l2dh6">Consulter le dossier</Typography>
            <Box>Votre dossier a bien été déposé. Vous pouvez désormais le consulter.</Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    columnGap: '16px',
                }}
            >
                <Button
                    variant="text"
                    sx={{
                        padding: '16px 24px',
                        alignItems: 'center',
                        color: 'primary.dark',
                    }}
                    onClick={handleCancel}
                >
                    Annuler
                </Button>
                <Button
                    variant="outlined"
                    onClick={handleSubmit}
                    sx={{
                        color: 'primary.contrastText',
                        backgroundColor: 'primary.dark',
                        padding: '16px 24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0 10px',
                        '&:hover': {
                            color: 'primary.dark',
                        },
                    }}
                >
                    Consulter mon dossier
                </Button>
            </Box>
        </Box>
    );
};

export default NavigateToExternalUrlModal;
